import { CONFIG } from '../../../../config'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../../util/date.service'

const { ENVIROMENT } = CONFIG

const InsumoHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/insumo`,

  async getInsumos(tpId) {
    try {
      const { id: user_id } = getUsuarioInfo()
      const url = `${this.baseURL}/${user_id}/${tpId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async insertInsumo(insumo) {
    try {
      const url = `${this.baseURL}`
      const response = await authHttp().post(url, insumo)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateInsumo(insumo) {
    try {
      const url = `${this.baseURL}`
      const response = await authHttp().put(url, insumo)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getInitInfoMovimentacao(p_inicial, p_final, tp_id) {
    try {
      const pInicial = parseToMysqlFormat(p_inicial)
      const pFinal = parseToMysqlFormat(p_final)
      const url = `${this.baseURL}/movimentacao-entrada-saida?p_inicial=${pInicial}&p_final=${pFinal}&tp_id=${tp_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async inserirMovimentoInsumo(movimento) {
    try {
      const { id: user_id } = getUsuarioInfo()
      const mov = {
        mov_date: parseToMysqlFormat(movimento.data_movimentacao),
        insumo_tp_id: movimento.insumo.id,
        operacao_id: movimento.operacao.id,
        qte: movimento.qte,
        user_id,
      }
      const url = `${this.baseURL}/movimentacao-entrada-saida`
      const response = await authHttp().post(url, mov)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async excluirMovimentoInsumo(movimentoId) {
    try {
      const url = `${this.baseURL}/movimentacao-entrada-saida/${movimentoId}`
      const response = await authHttp().delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPainelInsumoInitialInfo(selectedTp) {
    try {
      const { id: user_id } = getUsuarioInfo()
      const url = `${this.baseURL}/painel-insumo/init/${user_id}/${selectedTp}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPainelInsumoData(pInicial, pFinal, insumoId, selectedTp) {
    try {
      const { id: user_id } = getUsuarioInfo()
      const p_inicial = parseToMysqlFormat(pInicial)
      const p_final = parseToMysqlFormat(pFinal)

      const query = `p_inicial=${p_inicial}&p_final=${p_final}&insumo_id=${insumoId}&tp_id=${selectedTp}&user_id=${user_id}`
      const url = `${this.baseURL}/painel-insumo-stats?${query}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default InsumoHttp
